function TextAppear() {
	this.build();
}

TextAppear.prototype.build = function () {
	new SplitText("[data-text-appear]",
		{
			type: "lines,chars",
			charsClass: 'char',
			linesClass: 'line',
		});

	document.querySelectorAll('[data-text-appear]').forEach((elem) => {
		ScrollTrigger.create({
			trigger: elem,
			start: 'top bottom',
			once: true,
			toggleClass: {targets: elem, className: "appeared"}
		});
	});
};
